<template>
  <div id = "debtNotePostingDetail">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title"> Debt Note Posting Detail</div>
          <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
          <a href="javascript:void(0)" class="btn btn-secondary pull-right mr-2" v-on:click="exportReports()">
              <i class="fp-export"></i> Export
          </a>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content">
            <data-table-filter-config :moduleName="'debtNotePostingDetail'" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
              <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
              <section class="data-table bg-white">
                <custom-pagination
                        :page-changed="onPageChange"
                        :per-page-changed="onPerPageChange" :moduleName="'debtNotePostingDetail'" :position="'top'">
                </custom-pagination>
                <vue-good-table
                      ref="debtNotePostingDetailTable"
                      mode="remote"
                      title="Debt Note Posting Detail"
                      @on-page-change="onPageChange"
                      @on-selected-rows-change="selectionChanged"
                      @on-column-filter="onColumnFilter"
                      @on-per-page-change="onPerPageChange"
                      @on-sort-change="onSortChange"
                      :totalRows="totalRecords"
                      :columns="userColumns"
                      :rows="rows"
                      :pagination-options="{
                          enabled: false,
                          position: 'bottom',
                          perPage: perPage,
                          perPageDropdown:dropDownPerPage,
                          dropdownAllowAll: false,
                      }"

                      :search-options="{
                      enabled: false,
                      }">

                  </vue-good-table>
                  <custom-pagination
                          :page-changed="onPageChange"
                          :per-page-changed="onPerPageChange">
                  </custom-pagination>
              </section>
              </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
            <div class="container-fluid">
                <div class="bg-white text-center">
                    <h1>
                        Oops!</h1>
                    <h2>
                        403 </h2>
                    <div class="error-details">
                        Sorry!, You don't have permission to access this page.
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <loading-content></loading-content>
        </template>
        <app-footer></app-footer>
      </div>
  </div>
</template>
<script>
import Vue from 'vue';


import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
   name: "DebtNotePostingDetailReport",
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Debt Note Posting Detail | " +process.env.COPYRIGHT_NAME
    },
    mixins:[commonMixins,dataTableMixins],
    data: () => ({
      permissions:[],
      cantAccessPage:'',
      loading:false,
      userColumns: [],
      columns: [
          {
            label: 'Financier code',
            field: 'vendor_code',
            hidden:false,
            fpFieldType:"text",
            filterable: true

          },
          {
            label: 'Financier Name',
            field: 'vendor_name',
            hidden:false,
            fpFieldType:"text",
            filterable: true

          },
          {
            label: 'Note Reference Number',
            field: 'reference_number',
            hidden:false,
            fpFieldType:"text",
            filterable: true

          },
          {
            label: 'Sched Pmt Date',
            field: 'sched_pmt_date',
            fpFieldType:"date",
            hidden:false,
            filterable: true

          },
          {
            label: 'Posting Type',
            field: 'type',
            fpFieldType:"option",
            hidden:false,
            filterable : true,
            filterOptions: {
                filterDropdownItems: ['Principal','Interest'],
            },
            sortable:true

          },
          {
            label: 'Unit',
            field: 'asset_number',
            hidden:false,
            fpFieldType:"text",
            filterable: true

          },
          {
            label: 'Amount',
            field: 'amount',
            hidden:false,
            fpFieldType:"integer",
            type:'number',
            filterable: true,

          },
          {
            label: 'Posted Flag',
            field: 'posted_flag',
            fpFieldType:"option",
            hidden:false,
            filterable : false,
            sortable:false

          },
          {
            label: 'Facility',
            field: 'location',
            fpFieldType:"option",
            hidden:false,
            filterable : true,

          },
          {
            label: 'Pool',
            field: 'asset_pool',
            fpFieldType:"option",
            hidden:false,
            filterable : true,

          },
          {
            label: 'Date Created',
            field: 'date_created',
            fpFieldType:"date",
            hidden:false,
            filterable: true

          },
          {
            label: 'GL Company',
            field: 'gl_company',
            hidden:false,
            fpFieldType:"text",
            filterable: true

          },
          {
            label: 'GL Account',
            field: 'gl_account',
            hidden:false,
            fpFieldType:"text",
            filterable: true

          },
          {
            label: 'GL Year',
            field: 'gl_year',
            hidden:false,
            fpFieldType:"integer",
            filterable: true,

          },
          {
            label: 'GL Period',
            field: 'gl_period',
            hidden:false,
            fpFieldType:"integer",
            filterable: true,
            sortable:false,

          },
          {
            label: 'Interface Posting Sts',
            field: 'posting_status',
            hidden:false,
            fpFieldType:"text",
            filterable: false,
            sortable:false

          },
          {
            label: 'AP Tran Number',
            field: 'ap_tran_number',
            hidden:false,
            fpFieldType:"text",
            filterable: true

          },
          {
            label: 'GL Tran Number',
            field: 'gl_tran_number',
            hidden:false,
            fpFieldType:"text",
            filterable: true

          },
          {
            label: 'Invoice Number',
            field: 'inv_number',
            hidden:false,
            fpFieldType:"text",
            filterable: true

          },
          {
            label: 'Invoice Date',
            field: 'inv_date',
            fpFieldType:"date",
            hidden:false,
            filterable: true

          },
          {
            label: 'Company',
            field: 'company',
            hidden:false,
            fpFieldType:"option",
            filterable: true,
            filterOptions:{
              filterDropdownItems: ["000","001","002"],
            }

          },
          {
            label: 'Vendor Number',
            field: 'vendor_code',
            hidden:false,
            fpFieldType:"text",
            filterable: true,

          },
          {
            label: 'Voucher',
            field: 'voucher',
            hidden:false,
            fpFieldType:"text",
            filterable: true,

          },
          {
            label: 'GL Source Code',
            field: 'gl_source_code',
            hidden:false,
            fpFieldType:"text",
            filterable: true
          },
          {
            label: 'GL Journal Number',
            field: 'gl_journal_no',
            hidden:false,
            fpFieldType:"text",
            filterable: true
          },


      ],
      rows: [],
      totalRecords: 0,
      pageKey:"_debt_note_list_",
      batchProcess:0,
      batchNum:"",
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'debt_note_posting_detail_report') {
                    self.cantAccessPage = true;
                }
            });
        }
    },
    created: function() {
    },
    mounted: function () {

        this.getPermissions();

    },
    methods: {
      loadList() {
        var self = this;
        self.loading = true;
        var fields = {
              page: self.serverParams.page,
              perPage: self.serverParams.perPage,
              filters: self.serverParams.columnFilters,
              sort: self.serverParams.sort,
              action:self.action,
        };
        self.firstLoad = 1;
        $.ajax({
              url: process.env.ROOT_API + "/debt-note-posting-detail/list",
              type: "POST",
              data: fields,
              headers: this.ajxHeaders,
              dataType: "json",
              success: function (data) {
                  self.loading = false;
                  if (data.status == "success") {
                      if ( self.action == "export" ||  self.action == "export_queue") {
                          if ( data.code == "201" ) {
                              alert(data.message);
                          } else {
                              if ( self.action == "export" ) {
                                  self.excel = data.content.web;
                                  var save = document.createElement("a");
                                  save.href = self.excel;
                                  save.download = data.content.web;
                                  save.target = "_blank";

                                  document.body.appendChild(save);
                                  save.click();
                                  document.body.removeChild(save);

                              } else {

                                  self.batchProcess = 1;
                                  self.batchNum = data.content;
                              }
                          }
                          self.action = "list";
                          // self.loadList();
                      } else{
                        console.log(data.content.row);
                          self.rows = data.content.row;
                          self.totalRecords = data.content.totalRecords;

                      }
                  }else{
                      self.rows = data.content.row;
                      self.totalRecords = data.content.totalRecords;

                  }
              },
              error: function (jqXHR, exception) {
                  self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'debt-note-posting-detail')
              }
          });


      }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/reports/DebtNotePostingDetailReport.vue